<template>
  <v-container>
    <v-layout>
      <v-flex xs12 sm6 offset-sm3>
        <v-btn class="btn btn-secondary" @click="add">Add</v-btn>
        <v-btn class="btn btn-secondary copy-button" :data-clipboard-text="copyString" @click="copy">Copy</v-btn>

        <v-textarea hidden
          v-model="copyString"
        ></v-textarea>

        <v-spacer />  
        <v-text-field
          v-model="song"
          label="add song"
          clearable
          solo
          type="text"></v-text-field>
        <v-list id="setlist">
          <v-subheader>
            {{`Number of songs: ${setlist.length}`}}
          </v-subheader>

          <draggable
            :list="setlist"
            :options="{delay:300, animation:200}"
            class="list-group"
            @start="dragging = true"
            @end="dragging = false"
          >
            <template v-for="(item, index) in setlist">

              <v-list-tile class="list-group-item" :key="item.id" @click="">
                <v-list-tile-action :key="item.id">
                  <v-icon>drag_indicator</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title v-html="item.name"></v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-btn fab dark small depressed color="error" @click="remove(item.id)">
                    <v-icon dark>remove</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <!-- <v-divider v-if="index + 1 < setlist.length" :key="`divider-${index}`"></v-divider> -->
            </template>
          </draggable>
        </v-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import draggable from "vuedraggable";
import Clipboard from "clipboard";

const clipboard = new Clipboard(".copy-button");

clipboard.on('success', function(e) {
  console.log(e);
});

clipboard.on('error', function(e) {
  console.log(e);
});


export default {
  components: {
    draggable
  },
  data() {
    const list = JSON.parse(localStorage.getItem('my-setlist')) ?
      JSON.parse(localStorage.getItem('my-setlist')) :
      [];

    return {
      setlist: list,
      dragging: false,
      song: "",
      copyString: ""
    };
  },
  methods: {
    add: function() {
      this.setlist.push({ name: this.song, id: generateUuid()});
      localStorage.setItem('my-setlist', JSON.stringify(this.setlist));
      this.song = "";
    },
    remove: function(id) {
      this.setlist = this.setlist.filter((item) => {
        return item.id !== id
      });
      localStorage.setItem('my-setlist', JSON.stringify(this.setlist));
    },
    copy: function() {
      this.copyString = this.setlist.map((item) => {
        return item.name;
      }).join('\n');

      alert('Copied !')
    }
  }
};

function generateUuid() {
  // https://github.com/GoogleChrome/chrome-platform-analytics/blob/master/src/internal/identifier.js
  // const FORMAT: string = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
  let chars = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".split("");
  for (let i = 0, len = chars.length; i < len; i++) {
    switch (chars[i]) {
      case "x":
        chars[i] = Math.floor(Math.random() * 16).toString(16);
        break;
      case "y":
        chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16);
        break;
    }
  }
  return chars.join("");
}
</script>
<style scoped></style>